import React, { useState, useEffect, Fragment } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectCartItems } from "./Redux/shoppingCartReducer";
import "./i18n/config";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import ShoppingCartComponent from "./ShoppingCart";
import apiService from "./services/api.service";
import CompanyConfirmation from "./companyComponents/CompanyConfirmation";
import { eventService } from "./services/event.service";
import moment from "moment";

function ConfirmationComponent(props) {
  const [lang, setLang] = useState("");
  const [chainName, setChainName] = useState("");
  const [giftee, setGiftee] = useState(null);
  const [voucherNumber, setvoucherNumber] = useState("");
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const chainId = new URLSearchParams(location.search).get("chainid") || 0;
  let cartItems = useSelector(selectCartItems);
  const productsFromSession = window.sessionStorage.getItem("products");
  cartItems = productsFromSession ? JSON.parse(productsFromSession) : cartItems;
  const companyProducts = Object.values(cartItems)[0]
  const orderNUm = sessionStorage.getItem("lastOrderNum") || 0;
  const customer = sessionStorage.getItem("lastCustomer") ? JSON.parse(sessionStorage.getItem("lastCustomer")) : null;
  const productBlockingIdentifier = window.sessionStorage.getItem("productBlockingIdentifier");
  const companyUser = useSelector((state) => state.company.companyUser)
  const [order, setOrder] = useState(null);

  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
    if (orderNUm == 0 && !customer) {
      history.push(`/?chainid=${chainId}&lang=${new URLSearchParams(location.search).get("lang") || "eng"}`);
    }
    getMyOrder(orderNUm);

    if (productBlockingIdentifier) {
      apiService.unblockProduct(productBlockingIdentifier).then((response) => { }, (error) => { });
    }
  }, []);

  useEffect(() => {
    SetLanguage(lang);
    getChain();
  }, [lang]);

  const getChain = () => {
    apiService.getChains(chainId).then(
      (response) => {
        if (response.data && response.data.data && response.data.data.length > 0) {
          let transtext = getTranslations(response.data.data[0]);
          transtext = transtext && transtext.chainName ? transtext.chainName : response.data.data[0].name;
          setChainName(transtext)
        }
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  };

  const getMyOrder = (orderId) => {
    if (!companyUser) {
      apiService.getOrders({ orderId: orderId }).then(
        (response) => {
          if (response.data && response.data.data && response.data.data.length > 0) {
            const order = response.data.data[0]

            let newGiftee = {
              gifteeEmail: order.gifteeEmail,
              gifteeName: order.gifteeName,
              gifteePhone: order.gifteePhone,
              gifteeMessage: order.message
            };
            if (order.sendToGiftee) {
              setGiftee(newGiftee);
            }
            setvoucherNumber(order.voucherNumber);

            eventService.purchase(order);
          }
        },
        (error) => {
          const _content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      )
    }
  };

  const getTranslations = (objectToTranslate) => {
    if (objectToTranslate && objectToTranslate.translations) {
      let ObjectTranslations = objectToTranslate.translations.filter((p) => {
        return p.languageIsoCode == lang || p.languageIsoCode == new URLSearchParams(location.search).get("lang");
      });
      return ObjectTranslations.length > 0 ? ObjectTranslations[0] : {};
    }
    return {};
  };

  return (
    <div className={companyUser ? "confirmation-page-wrap company" : "confirmation-page-wrap"}>
      <div className="box">
        {companyUser ?
          <CompanyConfirmation
            giftee={giftee}
            orderNUm={orderNUm}
            chainName={chainName}
            companyProducts={companyProducts}
          />
          :
          <>
            <div className="top-line">
              <Row>
                <Col md={9}>{t("ThanksForRsv") + chainName}</Col>
                <Col className="top-rsv-num">{t("RsvNum")}{orderNUm}</Col>
              </Row>
            </div>
            <Row>
              <Col>
                <div className="rvs-dtl">
                  <div ><h5>{t("ReservationDetails")}</h5></div>
                  <div className="rsv-num">{t("RsvNum")}{orderNUm}</div>
                  <div className="rsv-num">{t("VoucherNum")}:{voucherNumber}</div>
                  <ShoppingCartComponent isConfirmation={true} ></ShoppingCartComponent>
                </div>
              </Col>
              <Col lg="4">
                <div className="customer-dtls">
                  {customer ? <div className="personal-dtls">
                    <div className="bold"><h5>{t("userDetails")}</h5></div>
                    <Row>
                      <Col>{t("FullName")}</Col>
                      <Col className="bold txt">{customer.customerFirstName + " " + customer.customerLastName}</Col>
                    </Row>
                    <Row>
                      <Col>{t("Email")}</Col>
                      <Col className="bold txt">{customer.customerEmail}</Col>
                    </Row>
                    <Row>
                      <Col>{t("Phone")}</Col>
                      <Col className="bold txt">{customer.customerPhone}</Col>
                    </Row>
                  </div> : null}
                  {giftee && giftee.gifteeName ? <div className="personal-dtls">
                    <Row>
                      <Col>{t("GiftReceiverFullName")}</Col>
                      <Col className="bold txt">{giftee.gifteeName}</Col>
                    </Row>
                    {giftee.gifteeEmail &&
                      <Row>
                        <Col>{t("GiftReceiverEmail")}</Col>
                        <Col className="bold txt">{giftee.gifteeEmail}</Col>
                      </Row>
                    }
                    {giftee.gifteePhone &&
                      <Row>
                        <Col>{t("GiftReceiverPhoneConf")}</Col>
                        <Col className="bold txt">{giftee.gifteePhone}</Col>
                      </Row>
                    }
                    {giftee.gifteeMessage &&
                      <>
                        <div className="greet-ttl">{t("greeting")}</div>
                        <div className="greet-msg" dangerouslySetInnerHTML={{ __html: giftee.gifteeMessage }}></div>
                      </>
                    }
                    {order && !order.sendToGifteeTime &&
                      <Row>
                        <Col>{t("VoucherWillSentNowTo")} <span className="bold txt">{giftee.gifteeName}</span>
                          <br />
                          {!!giftee.gifteePhone &&
                            <Fragment>
                              {t("ToPhone")} <span className="bold txt">{giftee.gifteePhone}</span>
                            </Fragment>
                          }
                          <br />
                          {!!giftee.gifteeEmail &&
                            <Fragment>
                              {t("ToEmail")} <span className="bold txt">{giftee.gifteeEmail}</span>
                            </Fragment>
                          }
                        </Col>
                      </Row>
                    }
                    {order && order.sendToGifteeTime &&
                      <Row>
                        <Col>{t("VoucherWillSentTo")} <span className="bold txt">{giftee.gifteeName}</span><br /> {t("OnDate")} {moment(order.sendToGifteeTime).format("DD/MM/YYYY")} {t("At")} {moment(order.sendToGifteeTime).format("HH:mm")}
                          <br />
                          {!!giftee.gifteePhone &&
                            <Fragment>
                              {t("ToPhone")} <span className="bold txt">{giftee.gifteePhone}</span>
                            </Fragment>
                          }
                          <br />
                          {!!giftee.gifteeEmail &&
                            <Fragment>
                              {t("ToEmail")} <span className="bold txt">{giftee.gifteeEmail}</span>
                            </Fragment>
                          }
                        </Col>
                      </Row>
                    }
                  </div> : null
                  }
                </div>
              </Col>
            </Row>
          </>}
      </div>
    </div>
  );
}

export default ConfirmationComponent;
